import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'

export const useInvalidateVatRates = () => {
  const queryClient = useQueryClient()

  const invalidateTaxRates = useCallback(() => {
    queryClient.invalidateQueries(QueryKeys.TaxRates)
  }, [queryClient])

  return {
    invalidateTaxRates,
  }
}
